import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=5724900c&scoped=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=5724900c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724900c",
  null
  
)

export default component.exports